export default __webpack_public_path__ + "static/media/51-min.0ea63e17.jpg";